import React from 'react';
import './DatePicker.css';

const DatePicker = ({ label, required, value, onChange, placeholder, error, inputClassName, isDisabled }) => {
  return (
    <div className="form-group">
      <label>
        {label} {required && <span style={{ color: 'red' }}>*</span>}
      </label>
      <input
        type="date"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`date-picker ${error ? 'error' : ''} ${isDisabled ? 'isDisabled' : ''} ${inputClassName}`}
        disabled={isDisabled}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default DatePicker;
